"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountCouponStatusEnum = void 0;
var AccountCouponStatusEnum;
(function (AccountCouponStatusEnum) {
  /** не активированный */
  AccountCouponStatusEnum[AccountCouponStatusEnum["non_activated"] = 1] = "non_activated";
  /** активированный */
  AccountCouponStatusEnum[AccountCouponStatusEnum["activated"] = 2] = "activated";
  /** заблокированный */
  AccountCouponStatusEnum[AccountCouponStatusEnum["blocked"] = 3] = "blocked";
  /** устаревший */
  AccountCouponStatusEnum[AccountCouponStatusEnum["expired"] = 4] = "expired";
})(AccountCouponStatusEnum = exports.AccountCouponStatusEnum || (exports.AccountCouponStatusEnum = {}));
/** @todo Почему в lingo2-account такой купон??? */
// export enum AccountCouponStatusEnum {
//   /** действует */
//   active = 1,
//   /** применён */
//   applied = 2,
//   /** отменен */
//   canceled = 3,
//   /** устарел */
//   expired = 4,
// }
